export const getUsersGroups = (state) => state.usersGroups